export const getInstallationTimeAsync = async () => new Date();
